import React, { useEffect, useState } from "react";
import { HandCoins } from "lucide-react";
import { toast } from "sonner";
import api, { taka } from "@/lib/api";
import { Modal, Field, inputCls, Th, Td, Empty, fmtDate } from "@/pages/admin/AdminUI";

export default function AdminDue() {
  const [data, setData] = useState({ customers: [], suppliers: [], payments: [] });
  const [pay, setPay] = useState(null); // { entity_type, entity_id, name, due }
  const [amount, setAmount] = useState(0);
  const [note, setNote] = useState("");

  const load = () => api.get("/admin/due").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (!amount) return toast.error("পরিমাণ দিন");
    await api.post("/admin/due/pay", { entity_type: pay.entity_type, entity_id: pay.entity_id, amount: Number(amount), note });
    toast.success("পেমেন্ট রেকর্ড হয়েছে"); setPay(null); setAmount(0); setNote(""); load();
  };

  const Section = ({ title, list, type }) => (
    <div className="bg-white rounded-2xl border border-stone-200 overflow-x-auto">
      <div className="p-4 font-bold text-[#1E3A2B]">{title}</div>
      <table className="w-full min-w-[480px]">
        <thead className="bg-stone-50 border-y border-stone-200"><tr><Th>নাম</Th><Th>মোবাইল</Th><Th>বাকি</Th><Th></Th></tr></thead>
        <tbody className="divide-y divide-stone-100">
          {list.map((x) => (
            <tr key={x.id}>
              <Td className="font-medium">{x.name}</Td><Td>{x.mobile}</Td>
              <Td className="text-red-600 font-semibold">{taka(x.due)}</Td>
              <Td><button onClick={() => { setPay({ entity_type: type, entity_id: x.id, name: x.name, due: x.due }); setAmount(x.due); }} className="text-sm bg-[#1E3A2B] text-white px-3 py-1.5 rounded-lg" data-testid={`pay-${type}-${x.id}`}>পেমেন্ট</button></Td>
            </tr>
          ))}
        </tbody>
      </table>
      {list.length === 0 && <Empty text="কোনো বাকি নেই" />}
    </div>
  );

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-[#1E3A2B] flex items-center gap-2"><HandCoins /> দেনা-পাওনা</h1>
      <Section title="কাস্টমার বাকি (পাওনা)" list={data.customers} type="customer" />
      <Section title="সরবরাহকারী বাকি (দেনা)" list={data.suppliers} type="supplier" />

      <div className="bg-white rounded-2xl border border-stone-200 overflow-x-auto">
        <div className="p-4 font-bold text-[#1E3A2B]">পেমেন্ট ইতিহাস</div>
        <table className="w-full min-w-[480px]">
          <thead className="bg-stone-50 border-y border-stone-200"><tr><Th>তারিখ</Th><Th>নাম</Th><Th>ধরন</Th><Th>পরিমাণ</Th></tr></thead>
          <tbody className="divide-y divide-stone-100">
            {data.payments.map((p) => (
              <tr key={p.id}><Td>{fmtDate(p.created_at)}</Td><Td>{p.entity_name}</Td><Td>{p.entity_type === "customer" ? "কাস্টমার" : "সরবরাহকারী"}</Td><Td className="font-semibold text-emerald-700">{taka(p.amount)}</Td></tr>
            ))}
          </tbody>
        </table>
        {data.payments.length === 0 && <Empty />}
      </div>

      <Modal open={!!pay} onClose={() => setPay(null)} title={`পেমেন্ট — ${pay?.name}`}>
        <div className="space-y-3">
          <div className="text-sm text-stone-500">মোট বাকি: <span className="font-semibold text-red-600">{taka(pay?.due)}</span></div>
          <Field label="পরিমাণ (৳)"><input type="number" className={inputCls} value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="due-amount" /></Field>
          <Field label="নোট"><input className={inputCls} value={note} onChange={(e) => setNote(e.target.value)} /></Field>
          <button onClick={submit} className="w-full bg-[#1E3A2B] text-white h-11 rounded-xl font-medium" data-testid="save-due-btn">পেমেন্ট রেকর্ড</button>
        </div>
      </Modal>
    </div>
  );
}
